import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Component({
  selector: 'avenir-select',
  standalone: true,
  imports: [],
  templateUrl: './select.component.html',
  styleUrl: './select.component.scss'
})
export class SelectComponent {
  displayMenu = false;
  @Input() selectedOption = '';
  @Input() iconSrc = '';
  @Output() emitSelected = new EventEmitter();
  @Input() options: { value: string; label: string; disabled?: boolean; }[] = [];
  @Input() disabled = false;
  @Input() flexColumn = false;
  @Input() label = 'Viewing';
  @Input() showLabel = true;
  @Input() placeholder = '';
  @Input() showPlaceholder = false;
  @Input() error: boolean | ValidationErrors = false;
  constructor(
  ) { }

  ngOnInit(): void {
  }

  toggleMenu(): void {
    this.displayMenu = !this.displayMenu;
  }

  closeMenu(): void {
    this.displayMenu = false;
  }

  selectOption(selected: { value: string; label: string; disabled?: boolean }) {
    if (selected.disabled) {
      return;
    }
    this.selectedOption = selected.label;
    this.emitSelected.emit(selected);
    this.closeMenu();
  }
}
